export const AutocompleteEventType = {
  Change: 'change',
  Reset: 'reset',
  Select: 'select',
};

export const AutocompleteProperty = {
  Id: 'id',
  Value: 'value',
  Label: 'label',
  Placeholder: 'placeholder',
  ColorScheme: 'colorScheme',
  LabelColorScheme: 'labelColorScheme',
  IconColor: 'iconColor',
  ErrorMessage: 'errorMessage',
  HideOnContentClick: 'hideOnContentClick',
  Options: 'options',
  IsLoading: 'isLoading',
  Disabled: 'disabled',
  IsShowErrorMessage: 'isShowErrorMessage',
  NoOptionsMessage: 'noOptionsMessage',
};

export default {
  AutocompleteEventType,
  AutocompleteProperty,
};
